import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import {
  Paper,
  Grid,
  Typography,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  withStyles,
  Theme,
} from "@material-ui/core";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { makeStyles, createStyles } from "@material-ui/core/styles";
import PrintTwoToneIcon from "@material-ui/icons/PrintTwoTone";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DescriptionRoundedIcon from "@material-ui/icons/DescriptionRounded";
import {
  getCenterInfo,
  getReportStatus,
  getBookingStatus,
  getBookingStatusCount,
  getReportDownload,
  getReportDownloadWithout,
} from "../../actions/GenomicsAction";
import Loader from "../../Components/loader";
import moment from "moment";
import { useHistory } from "react-router-dom";
import "./index.css";
import VisibilityTwoToneIcon from "@material-ui/icons/VisibilityTwoTone";
import AuditHistory from "../../Components/Comments/auditHistory";
const useStyles = makeStyles(() =>
  createStyles({
    paper: {
      width: "100%",
    },
    modal: {
      position: "absolute",
      width: "55%",
      top: "45%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
    center: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    container: {
      height: "500px",
    },
    centerIt: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    boxHover: {
      "&:hover": {
        transitionDuration: "0.3s",
        transitionProperty: "transform",
        borderBottom: "1px solid gray",
      },
    },
    boxActive: {
      "&:active": {
        borderBottom: "2px solid black",
      },
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    content: {
      width: "80%",
      flexGrow: 21,
      //   padding: theme.spacing(3),
    },
  })
);

const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const StyledTableRow:any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
interface Props {
  getReportDownloadWithout: any;
  reportDownloadWithout: any;
  getReportDownload: any;
  reportDownload: any;
  getBookingStatusCount: any;
  bookingStatusCount: any;
  getBookingStatus: any;
  bookingStatus: any;
  getReportStatus: any;
  reportStatus: any;
  getCenterInfo: any;
  centerInfo: any;
  loading: any;
}

const PatientReportStatus: React.FC<Props> = ({
  getReportDownloadWithout,
  reportDownloadWithout,
  getReportDownload,
  reportDownload,
  getBookingStatusCount,
  bookingStatusCount,
  getBookingStatus,
  bookingStatus,
  getReportStatus,
  reportStatus,
  getCenterInfo,
  centerInfo,
  loading,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [page, setPage] = useState(0);
  const timer = useRef<any>(0);
  const [centreName, setCentreName] = useState<any>("");
  const [fromDate, setFromDate] = React.useState<any>("");
  const [toDate, setToDate] = React.useState<any>("");
  const [phoneFilter, setPhoneFilter] = useState<any>("");
  const [nameFilter, setNameFilter] = useState<any>("");
  const [visitnoFilter, setVisitnoFilter] = useState<any>("");
  const [barcode, setBarcode] = useState<any>("");
  const [centre, setCentre] = useState<any>("");
  const [centreDetails, setCentreDetails] = useState<any>(null);
  const [tests, setTest] = useState<any>([]);
  const [rendered, setRendered] = useState<boolean>(false);
  const [rendered2, setRendered2] = useState<boolean>(false);

  const [openModal, setOpenModal] = useState<any>(false);
  const [openModal1, setOpenModal1] = useState<any>(false);
  const [dataForModal, setDataForModal] = useState<any>("");

  const filterForm = async (e: any) => {
    e.preventDefault();
    if (visitnoFilter !== "") {
      getReportStatus(`?id=${visitnoFilter}`);
    } else {
      getReportStatus(
        `?center__id=${centre}&customer_name=${nameFilter}&customer_phonenumber=${phoneFilter}${
          barcode === "" ? "" : "&qrcode=" + barcode
        }${
          fromDate === ""
            ? ""
            : "&start_date=" + moment(fromDate).format("YYYY-MM-DD")
        }${
          toDate === ""
            ? ""
            : "&end_date=" + moment(toDate).format("YYYY-MM-DD")
        }`
      );
    }


    getBookingStatusCount(
      `?center_id=${centre}${
        fromDate === ""
          ? ""
          : "&start_date=" + moment(fromDate).format("YYYY-MM-DD")
      }${
        toDate === "" ? "" : "&end_date=" + moment(toDate).format("YYYY-MM-DD")
      }`
    );
  };
  useEffect(() => {
    getCenterInfo();
    // getReportStatus(
    //   `${
    //     fromDate === ""
    //       ? ""
    //       : "start_date=" + moment(fromDate).format("YYYY-MM-DD")
    //   }${
    //     toDate === "" ? "" : "&end_date=" + moment(toDate).format("YYYY-MM-DD")
    //   }`
    // );
    getReportStatus();
    getBookingStatusCount(
      `${
        fromDate === ""
          ? ""
          : "?start_date=" + moment(fromDate).format("YYYY-MM-DD")
      }${
        toDate === "" ? "" : "&end_date=" + moment(toDate).format("YYYY-MM-DD")
      }`
    );
  }, []);

  const statusFilter = (url: any) => {
    getReportStatus(
      `?center__id=${centre}${
        fromDate === ""
          ? ""
          : "&start_date=" + moment(fromDate).format("YYYY-MM-DD")
      }${
        toDate === "" ? "" : "&end_date=" + moment(toDate).format("YYYY-MM-DD")
      }${url}`
    );
  };


  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = reportStatus.links && reportStatus.links.next.split("?")[1];
      getReportStatus(`?${url}`);
    } else if (newPage < page) {
      let url = reportStatus.links && reportStatus.links.previous.split("?")[1];
      getReportStatus(`?${url}`);
    }
    setPage(newPage as number);
  };

  const handleAuditHistory = (bId: any) => {
    setOpenModal1(true);
    setBookingId(bId);
  };
  const [bookingId, setBookingId] = useState<number>(0);

  const viewStatus = (bId: any) => {
    getBookingStatus(bId);
    setOpenModal(true);
  };
  const handleBoxRecieptOff = () => {
    setOpenModal(false);
  };
  const fetchDownload = (id: any) => {
    getReportDownload(id);
    setRendered(true);
  };
  useEffect(() => {
    if (Object.keys(reportDownload).length !== 0 && rendered === true) {
      handleDownloadReport();
      setRendered(false);
    }
  }, [reportDownload]);

  const handleDownloadReport = () => {
    if (reportDownload.message) {
      alert(reportDownload.message);
    } else {
      var b64 = reportDownload.allReportDetails.reportDetails;
      var bin = window.atob(b64);
      var link = document.createElement("a");
      link.download = `${reportDownload.allReportDetails.Patient_Name}-${reportDownload.allReportDetails.Age}.pdf`;
      link.href = "data:application/octet-stream;base64," + b64;
      link.click();
    }
  };
  const handleDOBForAge = (dob: any, bdate: any) => {
    const a: any = moment(bdate);
    const b: any = moment(dob);
    var years = a.diff(b, "year");
    b.add(years, "years");
    var months = a.diff(b, "months");
    b.add(months, "months");
    var days = a.diff(b, "days");
    if (months !== 0) {
      var age = months + "Months " + days + "Days";
    } else {
      var age = days + "Days";
    }

    return age;
  };
  const fetchDownloadWithout = (id: any) => {
    getReportDownloadWithout(id);
    setRendered2(true);
  };
  useEffect(() => {
    if (Object.keys(reportDownloadWithout).length !== 0 && rendered2 === true) {
      handleDownloadReportWithout();
      setRendered2(false);
    }
  }, [reportDownloadWithout]);

  const handleDownloadReportWithout = () => {
    if (reportDownloadWithout.message) {
      alert(reportDownloadWithout.message);
    } else {
      var b64 = reportDownloadWithout.allReportDetails.reportDetails;
      var bin = window.atob(b64);
      var link = document.createElement("a");
      link.download = `${reportDownloadWithout.allReportDetails.Patient_Name}-${reportDownloadWithout.allReportDetails.Age}.pdf`;
      link.href = "data:application/octet-stream;base64," + b64;
      link.click();
    }
  };
  return(
    <div
      style={{ padding: "40px 0 0 0", width: "100%" }}
      className={classes.content}
    >
      <Grid container style={{ margin: "5px auto" }}>
        {/* 1 */}
        <Grid item xs={12} style={{ alignItems: "left" }}>
          <Typography variant="h5" component="h5" align="center">
            <p style={{ fontWeight: "bold" }}> PATIENT REPORT STATUS </p>
          </Typography>
        </Grid>

        <Modal open={openModal}>
          <div className={classes.modal}>
            <Grid style={{ textAlign: "right" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleBoxRecieptOff}
              >
                Close
              </Button>
            </Grid>
            <Grid container item xs={12}>
              <Paper className={classes.paper} elevation={16}>
                <TableContainer
                  className={classes.tableContainer}
                  component={Paper}
                  style={{ maxHeight: "540px" }}
                >
                  <Table stickyHeader aria-label="simple table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell align="center">
                          <b>Booking Id</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Customer name</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Test Code</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Test Name</b>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <b>Status</b>
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {bookingStatus &&
                        bookingStatus.results &&
                        bookingStatus.count > 0 &&
                        bookingStatus.results.map((val: any) => (
                          <StyledTableRow style={{ border: "2px solid black" }}>
                            <StyledTableCell align="center">
                              {val?.booking?.id}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {val?.booking?.customer_name}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {val?.testCode}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {val?.testName}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {val?.status}
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          </div>
        </Modal>
        {/* 2 */}

        <Grid container xs={12}>
          <form
            onSubmit={filterForm}
            autoComplete="off"
            style={{ width: "100%" }}
          >
            <Grid container xs={12} spacing={2} className={classes.center}>
              {/* New Search Fields Added */}
              <Grid item xs={12} md={6} lg>
                <Autocomplete
                  id="center"
                  onChange={(event, newValue) => {
                    if (newValue) {
                      let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                      setCentre(obj.id);
                    }
                  }}
                  freeSolo
                  blurOnSelect
                  options={centerInfo?.results}
                  disableCloseOnSelect
                  getOptionLabel={(option: any) =>
                    (option?.display_name === null
                      ? option?.name
                      : option?.display_name) +
                    "(" +
                    option?.center_code +
                    ")"
                  }
                  onInputChange={(event, newInputValue) => {
                    getCenterInfo(`&name_or_code=${newInputValue}`);
                    setCentreName(newInputValue);
                    if (newInputValue === "") {
                      setCentre("");
                    }
                  }}
                  inputValue={centreName}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Hospital/Doctor"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6} lg>
                <TextField
                  fullWidth
                  onChange={(e) => setBarcode(e.target.value)}
                  variant="outlined"
                  label="Barcode No."
                  value={barcode}
                />
              </Grid>
              <Grid item xs={12} md={6} lg>
                <TextField
                  fullWidth
                  onChange={(e) => setVisitnoFilter(e.target.value)}
                  variant="outlined"
                  label="Booking Id"
                  value={visitnoFilter}
                />
              </Grid>
              <Grid item xs={12} md={6} lg>
                <TextField
                  fullWidth
                  onChange={(e) => setPhoneFilter(e.target.value)}
                  variant="outlined"
                  label="Phone No."
                  value={phoneFilter}
                />
              </Grid>

              <Grid item xs={12} md={6} lg>
                <TextField
                  fullWidth
                  onChange={(e) => setNameFilter(e.target.value)}
                  variant="outlined"
                  label="Patient Name"
                  value={nameFilter}
                />
              </Grid>

              <Grid item xs={12} md={6} lg>
                <form noValidate>
                  <TextField
                    fullWidth
                    name="fromDate"
                    label="From Date"
                    variant="outlined"
                    value={fromDate}
                    onChange={(e) => {
                      setFromDate(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true, required: true }}
                    type="date"
                    id="dateWidthCustom"
                  />
                </form>
              </Grid>

              <Grid item xs={12} md={6} lg>
                <form noValidate>
                  <TextField
                    fullWidth
                    name="toDate"
                    label="To Date"
                    variant="outlined"
                    value={toDate}
                    onChange={(e) => {
                      setToDate(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true, required: true }}
                    type="date"
                    id="dateWidthCustom"
                  />
                </form>
              </Grid>

              <Grid container xs={12} className={classes.center}>
                <Box
                  className={`${classes.boxHover} ${classes.boxActive} ${classes.centerIt}`}
                  style={{ margin: "5px", cursor: "pointer" }}
                  onClick={() => statusFilter("")}
                >
                  <Box
                    style={{
                      height: "20px",
                      width: "25px",
                      background: "#ffffff",
                      border: "0.1px solid black",
                    }}
                    className={classes.centerIt}
                  >
                    {bookingStatusCount?.total_count}
                  </Box>
                  <Box style={{ marginLeft: "5px" }}>
                    <b>All</b>
                  </Box>
                </Box>
                <Box
                  className={`${classes.boxHover} ${classes.boxActive} ${classes.centerIt}`}
                  style={{ margin: "5px", cursor: "pointer" }}
                  onClick={() => statusFilter("")}
                >
                  <Box
                    style={{
                      height: "20px",
                      width: "25px",
                      background: "var(--sample-status-booked)",
                      border: "0.1px solid black",
                    }}
                    className={classes.centerIt}
                  >
                    {bookingStatusCount?.booked}
                  </Box>
                  <Box style={{ marginLeft: "5px" }}>
                    <b>Booked</b>
                  </Box>
                </Box>
                <Box
                  className={`${classes.boxHover} ${classes.boxActive} ${classes.centerIt}`}
                  style={{ margin: "5px", cursor: "pointer" }}
                  onClick={() => statusFilter("&collected=True")}
                >
                  <Box
                    style={{
                      height: "20px",
                      width: "25px",
                      background: "var(--sample-status-collected)",
                      border: "0.1px solid black",
                    }}
                    className={classes.centerIt}
                  >
                    {bookingStatusCount?.collected}
                  </Box>
                  <Box style={{ marginLeft: "5px" }}>
                    <b>Collected</b>
                  </Box>
                </Box>
                <Box
                  className={`${classes.boxHover} ${classes.boxActive} ${classes.centerIt}`}
                  style={{ margin: "5px", cursor: "pointer" }}
                  onClick={() => statusFilter("&is_sync=true")}
                >
                  <Box
                    style={{
                      height: "20px",
                      width: "25px",
                      background: "var(--sample-status-acknowledged)",
                      border: "0.1px solid black",
                    }}
                    className={classes.centerIt}
                  >
                    {bookingStatusCount?.acknowledged}
                  </Box>
                  <Box style={{ marginLeft: "5px" }}>
                    <b>Acknowledged</b>
                  </Box>
                </Box>
                <Box
                  className={`${classes.boxHover} ${classes.boxActive} ${classes.centerIt}`}
                  style={{ margin: "5px", cursor: "pointer" }}
                  onClick={() => statusFilter("&report_status=consolidate")}
                >
                  <Box
                    style={{
                      height: "20px",
                      width: "25px",
                      background: "var(--sample-status-approved)",
                      border: "0.1px solid black",
                    }}
                    className={classes.centerIt}
                  >
                    {bookingStatusCount?.processed}
                  </Box>
                  <Box style={{ marginLeft: "5px" }}>
                    <b>Processed</b>
                  </Box>
                </Box>

                <Box
                  className={`${classes.boxHover} ${classes.boxActive} ${classes.centerIt}`}
                  style={{ margin: "5px", cursor: "pointer" }}
                  onClick={() => statusFilter("&booking_status=resampling")}
                >
                  <Box
                    style={{
                      height: "20px",
                      width: "25px",
                      background: "var(--sample-status-rejected)",
                      border: "0.1px solid black",
                    }}
                    className={classes.centerIt}
                  >
                    {bookingStatusCount?.psn_srn}
                  </Box>
                  <Box style={{ marginLeft: "5px" }}>
                    <b>PSN/SNR</b>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Grid container xs={12} className={classes.center}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ height: 35, margin: 15 }}
              >
                Search
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => history.push("/dashboard/gce/report_status")}
                style={{ height: 35, margin: 15 }}
              >
                Reset
              </Button>
            </Grid>
          </form>
        </Grid>
        {/* 4 */}
        <Grid container xs={12}>
          <Paper elevation={7} style={{ width: "100%" }}>
            <TableContainer className={classes.container}>
              {loading ? (
                <Loader />
              ) : (
                <Table stickyHeader aria-label="simple table">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell align="center">
                        <b>Sr No</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Booking Date</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Booking Id</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Patient</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Age</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Phone No.</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Processing Lab</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Tests</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Status</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>With letter head</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Without letter head</b>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <b>Audit History</b>
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {reportStatus.results &&
                      reportStatus.results.length > 0 &&
                      reportStatus.results.map((val: any, index: any) => {
                        return (
                          <StyledTableRow
                            key={index}
                            style={{
                              backgroundColor:
                                val?.status === "booked"
                                  ? "var(--sample-status-booked)"
                                  : val?.status === "collected"
                                  ? "var(--sample-status-collected)"
                                  : val?.status === "acknowledged"
                                  ? "var(--sample-status-acknowledged)"
                                  : val?.status === "processed"
                                  ? "var(--sample-status-approved)"
                                  : "var(--sample-status-rejected)",
                            }}
                          >
                            <StyledTableCell align="center">
                              {index + 1}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {moment(val?.booking_date).format("DD-MM-YYYY")}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {val?.booking_id}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {val?.customer_name}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {/* {val.age} */}
                              {val?.age === 0
                                ? handleDOBForAge(val?.dob, val?.booking_date)
                                : val?.age}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {val?.phone_no}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {val?.processing_lab}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {String(val?.package_name)}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <VisibilityTwoToneIcon
                                onClick={() => viewStatus(val?.booking_id)}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <PrintTwoToneIcon
                                onClick={() => fetchDownload(val?.booking_id)}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <PrintTwoToneIcon
                                onClick={() =>
                                  fetchDownloadWithout(val?.booking_id)
                                }
                              />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <DescriptionRoundedIcon
                                onClick={() =>
                                  handleAuditHistory(val?.booking_id)
                                }
                              />
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })}
                  </TableBody>
                  <TablePagination
                    rowsPerPageOptions={[]}
                    colSpan={4}
                    count={reportStatus.count}
                    rowsPerPage={reportStatus.page_size}
                    page={page}
                    onPageChange={handleChangePage}
                  />
                </Table>
              )}
            </TableContainer>
          </Paper>
          <AuditHistory
            openModal={openModal1}
            setopenModal={setOpenModal1}
            bookingId={bookingId}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  centerInfo: state.GenomicsCustomerExecutiveReducer.centerInfo,
  bookingStatusCount: state.GenomicsCustomerExecutiveReducer.bookingStatusCount,
  reportDownload: state.GenomicsCustomerExecutiveReducer.reportDownload,
  reportDownloadWithout: state.GenomicsCustomerExecutiveReducer.reportDownloadWithout,
  bookingStatus: state.GenomicsCustomerExecutiveReducer.bookingStatus,
  reportStatus: state.GenomicsCustomerExecutiveReducer.reportStatus,
  loading: state.GenomicsCustomerExecutiveReducer.loading,
});

export default connect(mapStateToProps, {
  getReportStatus,
  getBookingStatus,
  getBookingStatusCount,
  getReportDownload,
  getReportDownloadWithout,
  getCenterInfo,
})(PatientReportStatus);
